import Vue from "vue";
import axios from "axios";

const host = process.env.VUE_APP_URL;
const path = "v2/api/checkSession";

export default {
  check() {
    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
    axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
    return axios
      .get(host + path)
      .then((response) => {
        let res = response.data.data;
        return true;
      })
      .catch(() => {
        return false;
      });
  },
};
